module.exports = __webpack_public_path__ + "static/jcss_201903-a8a18aecb2f0215ddbf85616a56366af.png";